/* eslint-disable global-require */
export const getBrowserLanguage = () => {
  let browserLanguage = navigator.language || navigator.userLanguage;
  const matches = browserLanguage.match(/^([a-zA-Z]{2})/);
  if (matches && matches.length > 1) {
    [browserLanguage] = matches;
  }
  return browserLanguage;
};

const getLocalStorageLanguage = () => localStorage.getItem('language');

export const getLocale = () => getLocalStorageLanguage() || getBrowserLanguage() || 'en';

const getTranslations = () => {
  const req = require.context('./', true, /\.json.*$/);
  const translations = {};

  req.keys().forEach((file) => {
    const locale = file.replace(/\.\/(translations\/)?/, '').replace(/\.js(on)?$/, '');
    if (locale === 'en' && window.IntlPolyfill) {
      // require("./translations/en.js");
      require('@formatjs/intl-pluralrules/locale-data/en');
      //require("intl/locale-data/jsonp/en.js");
    } else if (locale === 'en') {
      //addLocaleData(require("react-intl/locale-data/en"));
      // addLocaleData(require("./translations/en.js"));
      require('@formatjs/intl-pluralrules/locale-data/en');
    } else if (locale === 'it' && window.IntlPolyfill) {
      // require('./translations/it.js');
      //require("intl/locale-data/jsonp/it.js");
      require('@formatjs/intl-pluralrules/locale-data/it');
    } else if (locale === 'it') {
      //addLocaleData(require("react-intl/locale-data/it"));
      // addLocaleData(require('./translations/it.js'));
      require('@formatjs/intl-pluralrules/locale-data/it');
    }
    translations[locale] = {
      ...req(file),
    };
  });
  return translations;
};

export const getMessages = () => getTranslations()[getLocale()] || {};
